import Name from './Name';
import withHandlers from 'recompose/withHandlers';

import formatAdventurerName from 'src/common/utils/format-adventurer-name';

const enhance = withHandlers({
  onHandleChange: props => event => {

    let formattedName = event.target.value;

    if (event.target.name === 'name' || event.target.name === 'surname') {
      formattedName = formatAdventurerName(formattedName);
    }

    if (props.trackNameChange) {
      props.trackNameChange(formattedName);
    }

    event.target.value = formattedName;
    props.onHandleChange(event);
  }
});

export default enhance(Name);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Adventurer/Name/index.js